(function (root) {
  "use strict";

  var copy = {
    pt: ["Os preços foram atualizados enquanto configurava. Reveja o novo total: {total}. As suas escolhas e os seus dados foram mantidos. Clique novamente para continuar.", "Não foi possível atualizar os preços. As suas escolhas foram mantidas. Tente novamente."],
    es: ["Los precios se actualizaron mientras configurabas. Revisa el nuevo total: {total}. Conservamos tus opciones y datos. Haz clic de nuevo para continuar.", "No se pudieron actualizar los precios. Conservamos tus opciones. Inténtalo de nuevo."],
    fr: ["Les prix ont été actualisés pendant votre configuration. Vérifiez le nouveau total : {total}. Vos choix et coordonnées sont conservés. Cliquez à nouveau pour continuer.", "Impossible d’actualiser les prix. Vos choix sont conservés. Réessayez."],
    it: ["I prezzi sono stati aggiornati durante la configurazione. Controlla il nuovo totale: {total}. Le tue scelte e i tuoi dati sono stati conservati. Fai di nuovo clic per continuare.", "Impossibile aggiornare i prezzi. Le tue scelte sono state conservate. Riprova."],
    en: ["Prices changed while you were configuring. Review the updated total: {total}. Your choices and details have been kept. Click again to continue.", "Prices could not be refreshed. Your choices have been kept. Please try again."]
  };

  function isPriceChange(error) {
    return /Campaign pricing changed\. Refresh the configuration before requesting a quote\./.test(String(error && error.message || error || ""));
  }

  // Mutate price fields in place: the wizard's steps hold references to these
  // option objects. Do not rebuild the wizard or clear selections/contact inputs.
  function applyPrices(current, fresh) {
    if (!fresh || !Number.isFinite(fresh.basePrice) || fresh.basePrice < 0 ||
        !Number.isFinite(fresh.transportPrice) || fresh.transportPrice < 0 || !fresh.stepData) {
      throw new Error("Invalid refreshed configurator prices");
    }
    var changes = [[current, "basePrice", fresh.basePrice], [current, "transportPrice", fresh.transportPrice]];
    Object.keys(current.stepData || {}).forEach(function (stepId) {
      var nextOptions = fresh.stepData[stepId] && fresh.stepData[stepId].options;
      if (!Array.isArray(nextOptions)) return; // Preserve presentation-only steps.
      (current.stepData[stepId].options || []).forEach(function (option) {
        var next = nextOptions.find(function (item) { return item.id === option.id; });
        if (!next) throw new Error("A configurator option changed; reload is required");
        ["price", "transportPrice"].forEach(function (key) {
          if (next[key] === undefined && option[key] === undefined) return;
          var value = next[key] === undefined ? 0 : next[key];
          if (!Number.isFinite(value) || value < 0) throw new Error("Invalid refreshed option price");
          changes.push([option, key, value]);
        });
      });
    });
    // Validate everything before changing any price.
    changes.forEach(function (change) { change[0][change[1]] = change[2]; });
    ["q4Campaign", "bundleDeliveryRegions", "deliveryPriceDetail"].forEach(function (key) {
      if (fresh[key] !== undefined) current[key] = fresh[key];
    });
  }

  function clear(buttonId) {
    if (!root.document) return;
    var notice = root.document.getElementById(buttonId + "-price-update");
    if (notice) notice.remove();
  }

  function notify(buttonId, message) {
    var button = root.document && root.document.getElementById(buttonId);
    if (!button) return;
    clear(buttonId);
    var notice = root.document.createElement("div");
    notice.id = buttonId + "-price-update";
    notice.setAttribute("role", "alert");
    notice.setAttribute("tabindex", "-1");
    notice.style.cssText = "padding:16px;margin:12px 0;border:1px solid currentColor;border-radius:8px;line-height:1.5";
    notice.textContent = message;
    button.parentNode.insertBefore(notice, button);
    notice.focus({ preventScroll: true });
  }

  async function recover(options) {
    var texts = copy[options.locale] || copy.en;
    var recovered = false;
    var message = texts[1];
    try {
      // GET only. Never repeat a quote/deposit/email submission automatically.
      var response = await options.fetchConfig();
      if (!response || !response.success || !response.config) throw new Error("Price refresh failed");
      var fresh = options.prepareConfig(response.config);
      applyPrices(options.current, fresh);
      options.render();
      message = texts[0].replace("{total}", options.total());
      recovered = true;
    } catch (error) {
      if (root.console) root.console.warn("[configurator] Price refresh failed:", error);
    } finally {
      options.unlock();
      (options.notify || notify)(options.buttonId, message);
    }
    return recovered;
  }

  var api = { isPriceChange: isPriceChange, applyPrices: applyPrices, recover: recover, clear: clear };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  else root.SaunamoPriceRefresh = api;
})(typeof window !== "undefined" ? window : globalThis);
